export default __webpack_public_path__ + "static/media/img_14.91a907c2.jpg";